import { create } from "zustand";
import { AbvType, DietaryType } from "../discovery/v2/DiscoveryV2SearchStore";
import { PriceType } from "../discovery/v2/filterCards/FilterPriceTypes";

export type SpotlightContainer =
  | "cask"
  | "keg"
  | "can"
  | "bottle"
  | "bag"
  | "pouch"
  | "bagInBox"
  | "jerryCan"
  | "box";

type SpotlightFilterState = {
  setState: (state: SpotlightFilterState) => void;
  selectedContainerTypes: SpotlightContainer[];
  addContainerType: (type: SpotlightContainer) => void;
  removeContainerType: (type: SpotlightContainer) => void;
  toggleContainerType: (type: SpotlightContainer) => void;
  setContainerTypes: (types: SpotlightContainer[]) => void;
  selectedAbvTypes: AbvType[];
  setAbvType: (abvType: AbvType[]) => void;
  selectedPrices: PriceType[];
  setSelectedPrices: (price: PriceType) => void;
  selectedDietaryTypes: DietaryType[];
  setDietaryType: (dietaryType: DietaryType[]) => void;
  clearContainerTypes: () => void;
  offersSellarCreditOnly: boolean;
  setOffersSellarCreditOnly: (offersSellarCreditOnly: boolean) => void;
  activeOnly: boolean;
  setActiveOnly: (active: boolean) => void;
  inactiveOnly: boolean;
  setInactiveOnly: (inactive: boolean) => void;
  search: string | null;
  setSearch: (search: string | null) => void;
  reset: () => void;
};

const initialStoreState = {
  selectedContainerTypes: [],
  selectedAbvTypes: [],
  selectedPrices: [],
  selectedDietaryTypes: [],
  offersSellarCreditOnly: false,
  activeOnly: false,
  inactiveOnly: false,
  search: null,
};

export const useSpotlightFilterStore = create<SpotlightFilterState>((set) => ({
  ...initialStoreState,
  setState: (newState: SpotlightFilterState) => set(newState),
  addContainerType: (type) =>
    set((state) => ({
      selectedContainerTypes: [...state.selectedContainerTypes, type],
    })),
  removeContainerType: (type) =>
    set((state) => ({
      selectedContainerTypes: state.selectedContainerTypes.filter(
        (t) => t !== type,
      ),
    })),
  toggleContainerType: (type) =>
    set((state) => ({
      selectedContainerTypes: state.selectedContainerTypes.includes(type)
        ? state.selectedContainerTypes.filter((t) => t !== type)
        : [...state.selectedContainerTypes, type],
    })),
  setContainerTypes: (types) => set({ selectedContainerTypes: types }),
  setAbvType: (abvType) => set({ selectedAbvTypes: abvType }),
  setSelectedPrices: (price) => set({ selectedPrices: [price] }),
  setDietaryType: (dietaryType) => set({ selectedDietaryTypes: dietaryType }),
  setOffersSellarCreditOnly: (offersSellarCreditOnly) =>
    set({ offersSellarCreditOnly }),
  clearContainerTypes: () => set({ selectedContainerTypes: [] }),
  setActiveOnly: (active) => set({ activeOnly: active }),
  setInactiveOnly: (inactive) => set({ inactiveOnly: inactive }),
  setSearch: (search) => set({ search }),
  reset: () => set(initialStoreState),
}));
